<template>
  <div class="payment-method-card card">
    <div class="payment-method-header d-flex flex-column align-items-center text-center p-3">
      <span class="fw-bold fs-5">{{ provider.label }}</span>
      <span class="badge mt-2" :class="subtotalBadgeClass">{{ subtotalLabel }}</span>
    </div>

    <div class="payment-method-detail p-3 border-top">
      <PaymentMethodInstance
          v-for="instance in provider.instances"
          :key="instance.configurationId"
          :instance="instance"
          :cc-total="ccTotal"
          @update-active="value => onUpdateInstance(instance.configurationId, 'active', value)"
          @update-percentage="value => onUpdateInstance(instance.configurationId, 'percentage', value)"
      />
    </div>
  </div>
</template>

<script>
import PaymentMethodInstance from "@/components/PaymentMethodInstance.vue";

export default {
  name: "PaymentMethodCard",
  components: { PaymentMethodInstance },
  props: {
    provider: {
      type: Object,
      required: true
    },
    // Sum of every active CC instance's percentage across all providers on the page —
    // forwarded straight through to each PaymentMethodInstance for slider capping.
    ccTotal: {
      type: Number,
      default: 0
    }
  },
  emits: ["update-instance"],
  computed: {
    hasCcInstances() {
      return this.provider.instances.some(i => i.percentage !== null && i.percentage !== undefined);
    },
    subtotal() {
      return this.provider.instances
          .filter(i => i.active && i.percentage !== null && i.percentage !== undefined)
          .reduce((sum, i) => sum + (i.percentage || 0), 0);
    },
    subtotalLabel() {
      return this.hasCcInstances ? `${this.subtotal}%` : "Non-CC";
    },
    subtotalBadgeClass() {
      if (!this.hasCcInstances) return "bg-secondary";
      return this.subtotal > 0 ? "bg-primary" : "bg-light text-muted border";
    }
  },
  methods: {
    onUpdateInstance(configurationId, field, value) {
      this.$emit("update-instance", { configurationId, field, value });
    }
  }
}
</script>

<style scoped>
.payment-method-card {
  flex: 0 0 360px;
  max-width: 360px;
}
.payment-method-header {
  min-height: 130px;
  justify-content: center;
}
</style>
